export const idCardTemplate = {
  width: 280,
  height: 160,
};
